import React from 'react';
import { Band, Stat } from './Band';
import { BillingAlertsSummary } from './useBillingAlertsSummary';

/**
 * L'état courant. Ces chiffres décrivent la situation d'aujourd'hui, pas une
 * consommation mesurée — d'où leur place AU-DESSUS du filtre de période : les
 * descendre en dessous laisserait croire qu'ils bougent avec lui.
 */
export const SnapshotBand: React.FC<{ summary: BillingAlertsSummary }> = ({ summary }) => {
	// Un zéro se lit comme un fait. Sur un écran dont tout le propos est « combien
	// on perd », afficher 0 pendant le chargement est le pire des affichages.
	const show = (value: string | number) => (summary.isLoading ? '—' : String(value));

	const stats: Stat[] = [
		{ value: show(summary.failedPaymentCount), label: 'paiements en échec', tone: 'critical' },
		{
			value: show(summary.unpaidDwAccounts),
			label: 'billing accounts managés sans abonnement actif',
			tone: 'critical',
		},
		{
			value: show(summary.managedProjects),
			label: 'projets managés actifs',
			tone: 'good',
		},
	];

	return <Band title="Aujourd'hui" note="indépendant du filtre de période" stats={stats} />;
};
